import { FC, AnchorHTMLAttributes, ReactNode } from 'react';
import { type PictogramName } from '../../../core-components';
import { twJoin } from 'tailwind-merge';
import type { DataAttributes } from '../../../utils';
import { DashboardCard } from '../DashboardCard';
type Props = DataAttributes & {
  title?: string;
  pictogramName?: PictogramName;
  spansRow?: boolean;
  fallback?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;
export const QuickAccessTile: FC<Props> = ({
  title,
  pictogramName,
  spansRow,
  fallback,
  ...rest
}) => {
  return <DashboardCard asChild fallback={fallback} title={title} pictogram={pictogramName} flexMobile={spansRow} className={spansRow ? 'col-span-2' : undefined} data-sentry-element="DashboardCard" data-sentry-component="QuickAccessTile" data-sentry-source-file="QuickAccessTile.tsx">
      <a {...rest} />
    </DashboardCard>;
};
export const QuickAccessTilesGroup: FC<{
  children: ReactNode;
  className?: string;
}> = ({
  children,
  className
}) => <div className={twJoin(className, 'grid grid-flow-row-dense auto-rows-fr grid-cols-2 gap-4')} data-sentry-component="QuickAccessTilesGroup" data-sentry-source-file="QuickAccessTile.tsx">
    {children}
  </div>;